import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import S from '../../../../stores';

const MESSAGES = {
    not_found: {
        title: 'Странно, но по таким фильтрам нет отзывов',
        message: 'Попробуйте убрать фильтр или сбросить все параметры',
        button: {
            title: 'Очистить фильтры',
            onClick: () => S.hotelReviews.resetFilters(),
        },
    },
    no_reviews: {
        title: 'На этот отель ещё нет отзывов',
        message: 'Расскажите о своём отдыхе, это поможет туристам сделать правильный выбор',
        button: {
             title: '',
             onClick: undefined,
             // TODO: пока что по задаче скрыта кнопка "Оставить отзыв"
            // title: 'Написать отзыв',
            // onClick: () => {},
        },
    },
    error: {
        title: 'Упс, при загрузке отзывов что-то сломалось, но вы не виноваты',
        message: 'Просто загрузите отзывы ещё раз, всё получится ',
        button: {
            title: 'Загрузить отзывы',
            onClick: () => S.hotelReviews.fetchInitReviews(),
        },
    },
};
const BASE_IMG_URL = 'https://static.sletat.ru/images/hotels/messages/';

export enum MessageType {
    NotFound = 'not_found',
    NoReviews = 'no_reviews',
    Error = 'error',
}

export interface MessageProps {
    type: MessageType;
}

interface StyledMessageProps extends JSSClassesProps<ComponentJSSClasses>, MessageProps {}

export const Message = observer((props: StyledMessageProps) => {
    const { classes, type } = props;

    const renderMessage = (messageType: MessageType) => {
        const { title, message, button } = MESSAGES[messageType];

        return (
            <article className={classes.container}>
                <div className={classes.leftInner}>
                    <img
                        src={`${BASE_IMG_URL}/${messageType}_msg.png`}
                        alt={messageType}
                        className={`${messageType}_img`}
                    />
                    <div className={classes.textWrapper}>
                        <div>
                            <h3 className={classes.messageTitle}>{title}</h3>
                            <p className={classes.messageText}>{message}</p>
                        </div>
                        {button.title ?
                            <button className={classes.button} onClick={button.onClick}>
                                {button?.title}
                            </button>
                        : null}
                    </div>
                </div>
            </article>
        );
    };

    return renderMessage(type);
});

export default Message;
